'use client'

import { getStoryblokApi } from '@vendure/marketing/util/server'
import { PropsWithChildren } from 'react'

export function StoryblokProvider({ children }: PropsWithChildren) {
  getStoryblokApi()
  return children
}
